import { FormField } from '@/types';
import Input from '@components/Form/Input';

function NumberField(props: FormField) {
  const {
    label,
    clean_name: cleanName,
    help_text: helpText,
    required,
    default_value: defaultValue,
    infotext,
    min_chars: minChars,
    max_chars: maxChars,
    pattern,
  } = props;

  return (
    <Input
      label={label}
      type='number'
      id={cleanName}
      placeholder={helpText}
      min={0}
      defaultValue={defaultValue ?? 1}
      required={required}
      infotext={infotext}
      min_chars={minChars}
      max_chars={maxChars}
      pattern={pattern}
    />
  );
}

export default NumberField;
